// components/Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-3 mt-auto">
      <div>
        <p style={{ margin: 0 }}>
          &copy; {new Date().getFullYear()} Zenovus Technologies Servies LLC.
          All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
